<template>
  <div class="block-wrap">
    <BlockTitle title-type="journal">
      <div @click="toList">更多期刊》</div>
    </BlockTitle>
    <div class="content-wrap">
      <div class="card-list-wrap">
        <div class="card-item" 
              :class="activeIndex === index ? 'active' : activeIndex -1 === index ? 'prev' : activeIndex + 1 === index ? 'next' : ''"
              v-for="(item, index) in list" :key="index">
          <div class="card-img"><img :src="item.coverImg || tempImg" alt=""></div>
          <div class="card-info">
            <h3 class="card-title" :title="item.title">{{item.title}}</h3>
            <div class="card-no" :title="item.periodicalNo">{{item.periodicalNo}}</div>
            <div class="card-detail"><i></i><i></i><i></i></div>
            <div class="card-desc">{{item.author || '-'}}</div>
            <div class="card-more" @click="toDetail(item)">查看详情</div>
          </div>
        </div>
        <div class="pagi">
          <div class="button-prev" :class="activeIndex === 0 ? 'disable' : ''" @click="onPrev"></div>
          <div class="button-next" :class="activeIndex === list.length - 1 ? 'disable' : ''" @click="onNext"></div>
        </div>
      </div>
    </div>
    <!-- <SplitLine /> -->
  </div>
</template>

<script>
import BlockTitle from "@/components/BlockTitle";
import tempImg from '@/assets/tempImages/qk.png';
import router from '@/router';

export default {
  data() {
    return {
      tempImg,
      activeIndex: 1
    }
  },
  components: {
    BlockTitle,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    onPrev() {
      if (this.activeIndex <= 0) return;
      this.activeIndex--;
    },
    onNext() {
      if (this.activeIndex >= this.list.length - 1) return;
      this.activeIndex++;
    },
    toList() {
      router.push('/publish');
    },
    toDetail(item) {
      router.push(`/publish/detail?aId=${item.id}`);
    },
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.block-wrap {

  .content-wrap {
    width: 100%;
    height: 400px;
    background: #F1F3F3;
    margin-bottom: 57px;

    .card-list-wrap {
      width: @middleWidth;
      margin: 0 auto;
      height: 400px;
      overflow: hidden;
      position: relative;

      .card-item {
        width: 240px;
        height: 100%;
        background: #FFFFFF;
        padding: 49px 44px 0 36px;
        display: flex;
        position: absolute;
        left: -240px;
        top: 0;
        transition: all .6s ease-in-out;
        cursor: pointer;

        .card-img {
          display: none;
        }

        .card-info {
          flex: 1;

          .card-title {
            &:extend(.line1);
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #0A2312;
            line-height: 40px;
            margin-bottom: 4px;
          }

          .card-no {
            &:extend(.line1);
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #0A2312;
            line-height: 28px;
          }

          .card-detail {
            margin-bottom: 24px;

            > i {
              display: inline-block;
              width: 6px;
              height: 6px;
              background: #06AE63;
              margin-right: 8px;
              border-radius: 50%;
            }
          }

          .card-desc {
            &:extend(.line3);
            height: 72px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
            line-height: 24px;
            margin-bottom: 32px;
          }

          .card-more {
            width: 120px;
            height: 40px;
            background: #F1F3F3;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131415;
            line-height: 40px;
            text-align: center;
          }
        }

        &.prev {
          left: 0;
        }
  
        &.next {
          left: unset;
          right: 0;
        }

        &.active {
          width: 720px;
          left: 240px;
          background: #06AE63;
          box-shadow: 0px 4px 20px 3px rgba(6, 174, 99, 0.3);
          padding: 40px 123px 0 59px;

          .card-img {
            display: block;
            width: 241px;
            height: 321px;
            border: 4px solid #FDFFFD;
            margin-right: 20px;

            > img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }

          .card-info {

            .card-title, .card-no {
              color: #FDFFFD;
            }

            .card-detail {
              > i {
                background: #FDFFFD;
              }
            }

            .card-desc {
              &:extend(.line5);
              height: 120px;
              color: #FDFFFD;
              margin-bottom: 22px;
            }

            .card-more {
              background: #FDFFFD;
              color: #06AE63;
            }
          }
        }
      }

      .pagi {
        width: 92px;
        height: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        right: 268px;
        bottom: 16px;

        > div {
          width: 36px;
          height: 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;

          &.button-prev {
            background-image: url(../../assets/images/arrow-left-1.png);
            margin-right: 20px;

            &.disable {
              // background-image: url(../../assets/images/active-prev-disable.png);
            }
          }

          &.button-next {
            background-image: url(../../assets/images/arrow-right-1.png);

            &.disable {
              // background-image: url(../../assets/images/active-next-disable.png);
            }
          }
        }
      }
    }
  }
}
</style>